import React, { useState, useEffect } from 'react';
import {
  Dropdown,
  FormControl,
  InputGroup,
  DropdownButton,
} from 'react-bootstrap';
import { bool, string } from 'prop-types';

import './DropdownSearch.sass';

const filterOptions = [
  {
    key: 'contains',
    name: 'contains',
    regex: '',
  },
  {
    key: 'starts',
    name: 'starts with',
    regex: '^',
  },
  {
    key: 'ends',
    name: 'ends with',
    regex: '$',
  },
];

function FilterInput({ applyFilter }) {
  const [value, setValue] = useState('');
  const [filterOption, setFilterOption] = useState(filterOptions[0].key);
  const selectFilterCondition = (eventKey) => setFilterOption(eventKey);

  // submit when user presses `Enter`
  const onPressEnter = (e) => {
    if (e.keyCode === 13) {
      applyFilter({ filterOption, value });
    }
  };

  return (
    <div style={{ position: 'absolute' }}>
      <InputGroup style={{ minWidth: '30ch' }} size="sm">
        <DropdownButton
          id="smart-table-search"
          as={InputGroup.Prepend}
          variant="outline-secondary"
          title={filterOption}
          onSelect={selectFilterCondition}
        >
          {filterOptions.map((p) => (
            <Dropdown.Item
              key={p.name}
              active={p.key === filterOption}
              eventKey={p.key}
            >
              {p.name}
            </Dropdown.Item>
          ))}
        </DropdownButton>
        <FormControl
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onKeyDown={onPressEnter}
        />
        <InputGroup.Append onClick={() => applyFilter({ filterOption, value })}>
          <InputGroup.Text>Seach</InputGroup.Text>
        </InputGroup.Append>
      </InputGroup>
    </div>
  );
}

function DropdownSearch({ keyValue, show = false }) {
  const [focused, setFocused] = useState(false);
  // close the search input when user clicks away

  // add event listener and clean on component unmount
  useEffect(() => {
    const handleClick = (e) => {
      if (e.target.closest(`.filter-${keyValue}`) === null) {
        setFocused(false);
      }
    };
    if (focused) {
      window.addEventListener('click', handleClick, true);
    }
    return () => {
      window.removeEventListener('click', handleClick, true);
    };
  }, [focused, keyValue]);

  // submit the filter string and conditions
  const applyFilter = ({ filterOption, value }) => {
    // eslint-disable-next-line no-console
    console.log(
      `selected filter option with value ${value} and eventKey ${filterOption}`,
    );
    setFocused(false);
  };

  return (
    <div className={`filter-${keyValue}`} style={{ position: 'relative' }}>
      <span
        className={`filter-show-on-hover ${show ? 'show' : ''}}`}
        onClick={() => setFocused(true)}
      >
        filter
      </span>
      {focused ? <FilterInput applyFilter={applyFilter} /> : null}
    </div>
  );
}

DropdownSearch.propTypes = {
  keyValue: string.isRequired,
  show: bool,
};

export default DropdownSearch;
